import { api, ServiceName } from './api';
import { logger } from '@/utils';
import {
  IWebHistoryItem,
  WebHistoryResponse,
} from '@/models/web-history.response';
import { LOGGER_ACTION, LOGGER_FEATURE } from '@/constants/logger/logger-tags';

class ApiWebHistory {
  public async postGoogleAuth(
    googleToken: string,
    needRedirectUri = false,
    redirectUrlAddress = ''
  ): Promise<WebHistoryResponse> {
    const data = {
      googleToken: googleToken,
      redirectUri: needRedirectUri,
      redirectUrlAddress: redirectUrlAddress,
    };
    try {
      return await api.httpPost<WebHistoryResponse>(
        ServiceName.WebHistory,
        '/suggestions/googleSignUp',
        data
      );
    } catch (error: any) {
      logger.error('Failed to post Google auth token for web history', error, {
        tags: {
          feature: LOGGER_FEATURE.WEB_HISTORY,
          action: LOGGER_ACTION.POST_GOOGLE_TOKEN,
        },
      });
      throw error;
    }
  }

  public async getUserWebHistory(uid: string): Promise<IWebHistoryItem[]> {
    const response = await api.httpGet<WebHistoryResponse>(
      ServiceName.WebHistory,
      `/suggestions/getByUuid/${encodeURIComponent(uid)}`
    );
    return response.suggestions;
  }
}

export const apiWebHistory = new ApiWebHistory();
